import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, mergeMap, of } from 'rxjs';
import { RootState } from '@store/create-store';
import { ToastNotification } from '@scenario/models/toast-notification.model';
import { displayToast } from '@store/toast-notifications/toast-notifications-slice';
import {
  downloadReleaseDocumentationFailure,
  downloadReleaseDocumentationSuccess,
} from '@store/scenario/release-documentation/release-documentation-slice';
import type { ReleaseDocumentationPayload } from '@store/scenario/release-documentation/release-documentation-slice';

export const downloadReleaseDocumentationEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('releaseDocumentation/downloadReleaseDocumentation'),
    concatMap((action: PayloadAction<ReleaseDocumentationPayload>) =>
      from(dependencies.releaseDocumentationGateway.downloadByFileName(
        action.payload.fileName,
        action.payload.originalFileName,
      )).pipe(
        mergeMap(() => {
          const toastNotification: ToastNotification = {
            title: 'Download Release Documentation',
            content: 'The release documentation file has been downloaded successfully',
            status: 'info',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          return of(downloadReleaseDocumentationSuccess(), displayToast(toastNotification));
        }),
        catchError(() => {
          const toastNotification: ToastNotification = {
            title: 'Download Release Documentation',
            content: 'Unable to download the release documentation',
            status: 'danger',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          return of(downloadReleaseDocumentationFailure('Error downloading release documentation'), displayToast(toastNotification));
        }),
      ),
    ),
  );
